import { fetch } from '@/utils/http'

export default {
  login: params => fetch('post', '/cbaas-service/login', params),
  logout: params => fetch('get', '/cbaas-service/v1/loginOut', params),
  updatePassword: params => fetch('put', '/cbaas-service/user/password', params),
  getMenuList: params => fetch('get', '/cbaas-service/v1/auth/moduleList', params),
  checkLicense: params => fetch('get', '/cbaas-service/verifyLicensed', params),
  updateLicense: params => fetch('post', '/cbaas-service/modifyFormalLicense', params),
  deleteLicense: params => fetch('post', '/cbaas-service/v1/config/deleteLicense', params),
  getCaptcha: params => fetch('get', '/cbaas-service/getCaptcha', params),
}
